// routes/AdminLayout.jsx

import React from "react";
import { Outlet } from "react-router-dom";
import withAdminLayout from "../layout/withAdminLayout";

const AdminLayout = () => {
  return <Outlet />;
};

export default withAdminLayout(AdminLayout);